import type { Entity } from "./adapter";

const airportToronto: Entity = {
  destinationId: "YYZ",
  name: "Toronto Pearson Intl. Airport (YYZ)",
  code: "YYZ",
  latitude: 43.6777,
  longitude: -79.6248,
  tts: true,
  type: "AIRPORTGROUP",
  ttsDestinationCode: "164",
  cubaDestination: false,
  useSPABookingFlow: false,
};

export default airportToronto;
